import {Component, Input} from '@angular/core';

/**
 * Generated class for the SearchResultComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'search-result',
  templateUrl: 'search-result.html'
})
export class SearchResultComponent {

  @Input()
  message: string;

  @Input()
  description: string

  @Input()
  icon: string;

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/search-result/search-result.ts